import * as dtt from "./data-types.js";
import * as dtv from "./data-validations.js";

export class DataField {

    constructor(fieldDef) {

        Object.assign(this, fieldDef);

        if (fieldDef.datatypeId) {
            this.datatypeId = fieldDef.datatypeId;
            this.datatype = dtt.getTypeById(this.datatypeId);
        } else {
            this.datatype = dtt.getTypeByName(fieldDef.type) || null;
            this.datatypeId = (this.datatype && this.datatype.id) || null;
        }
        this.format = fieldDef.format || dtt.getDefaultFormat(this.datatypeId);
        this.formatter = dtt.getFormatter(this.datatypeId, this.format);
        this.validations = [];
        this.availableValues = null;

        this.initializeValidations();

        return this;
    };

    initializeValidations() {

        if (this.required)
            this.validations.push(dtv.required());

    };

    prepare(codelistValueLoader = null) {

        let datatype = dtt.getTypeById(this.datatypeId);

        if (!datatype)
            return new Promise.reject(new Error('Field\'s datatype not found.'));

        if (!dtt.isCodelistType(datatype)) {
            this.$prepared = true;
            return Promise.resolve(true);
        }

        return dtt.loadTypeValues(datatype, codelistValueLoader)
            .then(() => {

                this.availableValues = () => dtt.getTypeValues(datatype);
                this.formatter = dtt.getCodelistFormatter(datatype, this.availableValues);

                this.$prepared = true;
                return true;

            });

    };

    // --------------------------------------------------------------------------------------------

    getValidations() {

        return (typeof this.validations == 'function' ? this.validations.call(this) : this.validations);

    };

    validateValue(data) {

        if (!data) return false;

        var value = this.getValue(data);

        return (this.validations || []).every((validation) => validation.validate(value));

    };

    getValueError(data) {

        if (!data)
            return [];

        return dtv.getValueError(this.getValue(data), this.validations || []);

    };

    // --------------------------------------------------------------------------------------------

    getAvailableValues() {
        return (typeof this.availableValues == 'function') ? this.availableValues.call(this) : this.availableValues;
    };

    getValue(data) {
        if (!data)
            return undefined;
        let actualData = (typeof data == 'function') ? data() : data;
        return actualData[this.name];
    };

    setValue(data, value) {
        this.changeValue(data, value, true);
        return this;
    };

    changeValue(data, value, force = false) {
        if (!data)
            return false;
        let actualData = (typeof data == 'function') ? data() : data,
            actualValue = (actualData && actualData[this.name]) || null;
        if (!force && actualValue == value)
            return false;
        actualData[this.name] = value;
        actualData.$changed = true;
        return true;
    };

    formatValue(value, format = null) {
        if (!(this.formatter && this.formatter.format))
            return value;
        return this.formatter.format(value, format ?? this.format);
    };

    parseValue(value, format = null) {
        if (this.formatter && this.formatter.parse)
            return this.formatter.parse(value, format ?? this.format);
        return value;
    };

    getFormattedValue(data, format = null) {
        return this.formatValue(this.getValue(data), format ?? this.format);
    };

    setParsedValue(data, value, format = null) {
        return this.setValue(data, this.parseValue(value, format ?? this.format));
    };

    serializeWireValue(value) {
        if (this.formatter && typeof this.formatter.serializeWire == 'function')
            return this.formatter.serializeWire(value, this.format);
        return value;
    };

    deserializeWireValue(value) {
        if (this.formatter && typeof this.formatter.deserializeWire == 'function')
            return this.formatter.deserializeWire(value, this.format);
        return value;
    };

}
